import { useQuery } from '@tanstack/react-query'

import client from '~/clients/api-client'

import { MultiQueryOptions } from '../../entities/useMultiQuery'
import { handleApiRequest } from '../../optimus/shared/apiWrapper'

export const useListViewOptionProfiles = (options?: MultiQueryOptions) =>
    useQuery({
        queryKey: ['viewOptionProfiles'],
        queryFn: async () => handleApiRequest(() => client.viewOptionProfiles.list()),
        retry: 0,
        enabled: !options?.skip,
    })
